import { Typography } from '@mui/material';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import useDebounce from '../../../hooks/useDebounce';
import { useUserProjects } from '../../../query/apiQueries';
import { projectTableHead } from '../../../static-data/projects';
import SearchBar from '../../elements/SearchBar';
import TableComponent from '../../elements/TableComponent';
import EditUserProject from './EditUserProject';
import FavouriteProjectToggle from './FavouriteProjectToggle';
import ProjectTableAction from './ProjectTableAction';

const UserProjectSection = () => {
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [order, setOrder] = useState('desc');
  const [searchValue, setSearchValue] = useState('');
  const debouncedSearchQuery = useDebounce(searchValue, 500);

  const {
    data: projectData,
    isLoading,
    refetch,
  } = useUserProjects({
    perPage: perPage,
    page: page,
    search: debouncedSearchQuery,
    includeTestCases: false,
    includeLinkedProjects: true,
  });

  const projects = projectData?.projects || [];
  const totalCount = projectData?.total || 0;

  const handlePageSizeChange = (e) => {
    const newPerPage = parseInt(e.target.value, 10);
    setPerPage(newPerPage);
    setPage(1);
  };
  return (
    <>
      <Row>
        <Col>
          <Typography variant="h4" className="mb-3">
            Projects
          </Typography>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col className="d-flex">
          <SearchBar
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            clearSearch={() => setSearchValue('')}
            placeholder="Search Projects"
          />
        </Col>
        <Col className="d-flex justify-content-end">
          <ProjectTableAction fetchProjectData={refetch} />
        </Col>
      </Row>

      <Row>
        <Col>
          <TableComponent
            data={projects || []}
            headerTabs={projectTableHead}
            page={page}
            setPage={setPage}
            perPage={perPage}
            order={order}
            setOrder={setOrder}
            defaultSort="created_at"
            isLoading={isLoading}
            striped
            totalCount={totalCount}
            showPages
            handlePageChange={setPage}
            tablekey="projects"
            showCount
            showRowCount={true}
            setPerPage={handlePageSizeChange}
            action={(row) => (
              <>
                <FavouriteProjectToggle
                  projectId={row.id}
                  isMarkedFavourite={row.is_favourite}
                  refetch={refetch}
                />
                <EditUserProject
                  selectedProject={row}
                  fetchProjectData={refetch}
                />
              </>
            )}
          />
        </Col>
      </Row>
    </>
  );
};

export default UserProjectSection;
